/**
 * src/main.jsx — SPA entry point. Mounts <App/> and nothing else; all routing
 * and auth state live in App.jsx.
 */
import React from 'react';
import ReactDOM from 'react-dom/client';

import App from './App.jsx';
import { applyStoredTheme } from './lib/theme.js';
import { injectThemeTokens } from './lib/apply-theme.js';
import './styles.css';
import './components/ui/ui.css';

// Token stylesheet first — styles.css's rules below read these custom
// properties, and this also supersedes index.html's inline critical-CSS
// fallback (see that file's comment on load order).
injectThemeTokens();

// Also set synchronously in index.html's inline script, ahead of first
// paint; this call keeps the two in sync and covers the case where that
// script didn't run (e.g. tests mounting main.jsx directly).
applyStoredTheme();

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
